import { Commerce } from '@kotipizzagroup/kotipizza-shared-types';
import { useAllProductItems } from '../../../state/product/hooks/useAllProductItems';
import { ProductItem } from '../types';
import { TAP_DRINK_PRODUCT_ID } from '../../menu/hooks/useMenuDisplayGroups';

export const useLunchDrinks = (): {
  smallDrinks: ProductItem[];
  largeDrinks: ProductItem[];
  isLoading: boolean;
  error: unknown;
} => {
  const { products: drinks, isLoading, error } = useAllProductItems();
  const SmallDrinksSizes = [Commerce.ProductSize.DRINK_MEDIUM, Commerce.ProductSize.DRINK_TAP];
  const LargeDrinkSizes = [Commerce.ProductSize.DRINK_LARGE, Commerce.ProductSize.DRINK_TAP];

  return {
    smallDrinks: drinks
      .filter((drink) => SmallDrinksSizes.includes(drink.sizeId))
      .sort((drink) => (drink.productID === TAP_DRINK_PRODUCT_ID ? -1 : 0)),
    largeDrinks: drinks
      .filter((drink) => LargeDrinkSizes.includes(drink.sizeId))
      .sort((drink) =>
        drink.sizeId === Commerce.ProductSize.DRINK_TAP && drink.productID === TAP_DRINK_PRODUCT_ID
          ? -1
          : 0
      ),
    isLoading,
    error,
  };
};
